<template>
    <div id="cofiscart" class="cc-theme cc-theme--four-step">
        <nav class="cc-steps__navigation">
            <ul class="cc-steps__navigation__list">
                <li class="cc-steps__navigation__list__item" v-bind:class="{'cc-active': isActiveStep(1)}" @click="setActiveStep(1)">
                    <span>01. {{ translations['Order summary'] }}</span>
                </li>
                <li class="cc-steps__navigation__list__item" v-bind:class="{'cc-active': isActiveStep(2)}" @click="setActiveStep(2)">
                    <span>02. {{ translations['Carrier and payment'] }}</span>
                </li>
                <li class="cc-steps__navigation__list__item" v-bind:class="{'cc-active': isActiveStep(3)}" @click="setActiveStep(3)">
                    <span>03. {{ translations['Address'] }}</span>
                </li>
                <li class="cc-steps__navigation__list__item" v-bind:class="{'cc-active': isActiveStep(4)}" @click="setActiveStep(4)">
                    <span>04. {{ translations['Order completion'] }}</span>
                </li>
            </ul>
        </nav>
        <div class="cc-steps__content cc-theme__information">
            <step1 v-if="isActiveStep(1)" @setActiveStep="setActiveStep"/>
            <step2 v-if="isActiveStep(2)" @setActiveStep="setActiveStep"/>
            <step3 v-if="isActiveStep(3)" @setActiveStep="setActiveStep"/>
            <step4 v-if="isActiveStep(4) && step4layout === 'long'" @setActiveStep="setActiveStep"/>
            <step4-a v-if="isActiveStep(4) && step4layout === 'two-columns'" @setActiveStep="setActiveStep"/>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Step1 from "./Step1";
    import Step2 from "./Step2";
    import Step3 from "./Step3";
    import Step4 from "./Step4";
    import Step4A from "@/components/FourStep/Step4A";

    export default {
        components: {
            Step4A,
            Step1,
            Step2,
            Step3,
            Step4,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                activeStep: state => state.activeStep,
                products: state => state.products,
                selectedCountry: state => state.user.deliveryAddress.country,
                selectedCarrier: state => state.selectedCarrier,
                selectedPayment: state => state.selectedPayment,
                isRegistrationRequested: state => state.user.requestRegistration,
                hasUserPasswordError: state => state.user.errors.password,
                hasLoginCountryMismatchError: state => state.errors.loginCountryMismatch,
                step4layout: state => state.config.theme_settings.step4layout,
            }),
        },
        methods: {
            isActiveStep: function (index) {
                return index === this.activeStep;
            },
            setActiveStep: function (index) {
                if (index === 1) {
                    this.$store.commit('SET_ACTIVE_STEP', index);
                    this.scrollToNavigation();
                }

                if (index === 2) {
                    if (this.isStep1Done()) {
                        this.$store.commit('SET_ACTIVE_STEP', index);
                        this.scrollToNavigation();
                    } else {
                        this.$store.commit('SET_ACTIVE_STEP', 1);
                        this.scrollToNavigation();
                    }
                }

                if (index === 3) {
                  if (this.validateStep2() === false) {
                    return;
                  }
                  this.$store.commit('SET_ACTIVE_STEP', index);
                  this.scrollToNavigation();
                }

                if (index === 4) {
                  if (this.validateStep3() === false) {
                    return;
                  }
                    let that = this;

                    this.$store.dispatch('VALIDATE_WHOLE_USER')
                        .then(function () {
                            if (!that.hasUserError() && that.isUserPasswordValid()) {
                                that.$store.commit('SET_ACTIVE_STEP', index);
                                that.scrollToNavigation();
                            } else {
                                if (that.$store.getters.hasUserError) {
                                    that.$store.commit('SET_ACTIVE_STEP', 3);

                                    const erroneousInput = document.querySelector('.cc-invalid');

                                    erroneousInput.parentNode.scrollIntoView({
                                        behavior: "smooth",
                                        block: "start",
                                    });
                                }
                            }
                        }).then(() => {
                            return that.$store.dispatch('LOAD_CARRIERS_AND_PAYMENTS');
                        }).then(() => {
                            return that.$store.commit('SELECT_CARRIER', that.selectedCarrier);
                        }).then(() => {
                            return Promise.all([
                                that.$store.dispatch('UPDATE_SHIPMENT_WITH_PAYMENT_PRICE'),
                                that.$store.dispatch('SYNC_SUMMARY')
                            ]);
                        });
                }
            },
            isStep1Done: function() {
                if (!this.areProductsInCart()) {
                    this.$store.commit('SET_ACTIVE_STEP', 1);
                    this.scrollToNavigation();
                }

                return this.areProductsInCart();
            },
            isStep2Done: function() {
                return this.isStep1Done()
                    && this.isCountrySelected()
                    && this.isCarrierSelected()
                    && this.isPaymentSelected()
                    && !this.hasLoginCountryMismatchError;
            },
            isStep3Done: function() {
                return this.isStep2Done()
                    && !this.hasUserError()
                    && this.isUserPasswordValid();
            },
            validateStep2: function () {
              if (this.isStep2Done()) {
                return true;
              }
              if (this.hasLoginCountryMismatchError) {
                document.querySelector('.cc-alert.cc-alert--error.cc-alert--with-background').scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });

                return false;
              }

              if (!this.selectedCountry) {
                this.$store.commit('SET_ACTIVE_STEP', 2);
                document.getElementById('deliveryAddress.country').classList.remove('cc-invalid');
                document.getElementById('deliveryAddress.country').classList.add('cc-invalid');
                document.querySelector('.cc-content--country').scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });

                return false;
              } else {
                if (this.activeStep === 2) {
                  document.getElementById('deliveryAddress.country').classList.remove('cc-invalid');
                }
              }

              if (!this.selectedCarrier) {
                this.$store.commit('SET_ACTIVE_STEP', 2);
                document.querySelectorAll('.cc-carrier').forEach(item => {
                  item.classList.remove('cc-invalid')
                });
                document.querySelectorAll('.cc-carrier').forEach(item => {
                  item.classList.add('cc-invalid')
                });
                document.querySelector('.cc-content--carriers').scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });

                return false;
              } else {
                if (this.activeStep === 2) {
                  document.querySelectorAll('.cc-carrier').forEach(item => {
                    item.classList.remove('cc-invalid')
                  });
                }
              }

              if (!this.selectedPayment) {
                this.$store.commit('SET_ACTIVE_STEP', 2);
                document.querySelectorAll('.cc-payment').forEach(item => {
                  item.classList.remove('cc-invalid')
                });
                document.querySelectorAll('.cc-payment').forEach(item => {
                  item.classList.add('cc-invalid')
                });
                document.querySelector('.cc-content--payments').scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });

                return false;
              } else {
                if (this.activeStep === 2) {
                  document.querySelectorAll('.cc-payment').forEach(item => {
                    item.classList.remove('cc-invalid')
                  });
                }
              }
            },
            validateStep3: function () {
              if (!this.isStep2Done()) {
                this.$store.commit('SET_ACTIVE_STEP', 2);
                return false;
              }
              if (this.hasUserError() || this.isUserPasswordValid() === false) {
                this.$store.commit('SET_ACTIVE_STEP', 3);
                return false;
              }
              return true;
            },
            areProductsInCart: function() {
                return this.products && this.products.length > 0;
            },
            isCountrySelected: function() {
                return this.selectedCountry;
            },
            isCarrierSelected: function() {
                return this.selectedCarrier;
            },
            isPaymentSelected: function() {
                return this.selectedPayment;
            },
            hasUserError: function() {
                return this.$store.getters.hasRegistrationError;
            },
            isUserPasswordValid: function() {
                if (this.isRegistrationRequested) {
                    return !this.hasUserPasswordError;
                }

                return true;
            },
            scrollToNavigation: function () {
                document.querySelector('.cc-steps__navigation').scrollIntoView({
                    behavior: 'smooth',
                    block: "start",
                });
            },
        },
        name: 'FourStep',
    };
</script>

<style lang="scss">
    @import "./scss/main";

    #app {
        .cc-theme--four-step {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 3rem;
        }

        .cc-theme--four-step {
            .cc-steps__navigation {
                display: block;
                width: 100%;
                max-width: 100%;
            }

            .cc-steps__navigation__list {
                display: flex;
                align-items: stretch;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: flex-start;
                width: 100%;
                max-width: 100%;
            }

            @include mobile {
                .cc-steps__navigation__list {
                    flex-direction: column;
                }
            }

            .cc-steps__navigation__list__item {
                font-size: 16px;
                font-weight: bold;
                display: flex;
                align-items: center;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: center;
                width: 25%;
                padding: 1.5rem;
                border-style: solid;
                border-radius: 3px 3px 0 0;
                text-align: center;

                &.cc-active {
                    cursor: default;
                    color: $dark-grey;
                    border-width: 3px 3px 3px 3px;
                    border-color: $orange $orange transparent $orange;
                }

                &:not(.cc-active) {
                    cursor: pointer;
                    color: $light-grey;
                    border-width: 3px 0 3px 0;
                    border-color: transparent transparent $orange transparent;
                    background: $navigation-background-color;
                }
            }

            @include mobile {
                .cc-steps__navigation__list__item {
                    width: 100%;
                    margin-bottom: 0.5rem;

                    &:not(.cc-active) {
                        border-width: 0;
                        border-color: transparent;
                    }
                }
            }
        }
    }
</style>
